import { ensureItemsModalState } from './state.js';

export async function removeItemElement(fdiId) {
    const state = ensureItemsModalState(this);
    const itemElement = document.querySelector(`[data-fdi-id="${fdiId}"]`);

    state.items = state.items.filter((item) => String(item.fdi_id || item.id) !== fdiId);
    state.filteredItems = state.filteredItems.filter((item) => String(item.fdi_id || item.id) !== fdiId);
    state.selectedIds.delete(fdiId);

    if (!itemElement) {
        this.refreshCachedItems();
        return;
    }

    itemElement.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
    itemElement.style.opacity = '0';
    itemElement.style.transform = 'translateX(-12px)';

    await new Promise((resolve) => {
        setTimeout(resolve, 250);
    });

    itemElement.remove();
    this.refreshCachedItems();
}

export function decrementCollectionCount(amount) {
    const collectionId = Number(this.currentCollectionId);
    if (!collectionId || Number.isNaN(collectionId)) {
        return;
    }

    const collection = this.collections.find((item) => item.id === collectionId);
    if (collection) {
        const updatedCount = Math.max(0, (collection.item_count || 0) - amount);
        collection.item_count = updatedCount;

        const cardCount = document.querySelector(`[data-collection-id="${collectionId}"] .items-count`);
        if (cardCount) {
            const suffix = this.collectionStrings?.projectSuffix || 'dự án';
            cardCount.textContent = `${updatedCount} ${suffix}`;
        }
    }
}

export function refreshCachedItems() {
    const state = ensureItemsModalState(this);
    const listContainer = document.getElementById('items-list');
    if (!listContainer) {
        state.cachedElements = [];
        return;
    }

    const items = Array.from(listContainer.querySelectorAll('.fdi-item'));
    state.cachedElements = items.map((element) => {
        const titleElement = element.querySelector('h3');
        if (titleElement && !titleElement.dataset.originalTitle) {
            titleElement.dataset.originalTitle = titleElement.textContent || '';
        }

        return {
            element,
            fdiId: String(element.dataset.fdiId || ''),
            title: (titleElement?.textContent || '').toLowerCase(),
        };
    });
}

export function updateItemsAfterMutation() {
    const state = ensureItemsModalState(this);
    this.refreshCachedItems();
    this.updateItemsCount();
    this.toggleBulkActionsHeader();
    this.syncItemsEmptyState();

    if (state.searchTerm) {
        this.updateSearchResultsInfo(state.filteredItems.length);
        if (state.filteredItems.length === 0) {
            this.showNoResultsState(state.searchTerm);
        } else {
            this.hideNoResultsState();
            this.applySearchHighlight(state.searchTerm);
        }
    } else {
        this.hideSearchResultsInfo();
        this.hideNoResultsState();
    }
}

export function syncItemsEmptyState() {
    const state = ensureItemsModalState(this);
    const listContainer = document.getElementById('items-list');
    const emptyState = document.getElementById('items-empty');

    if (!listContainer || !emptyState) {
        return;
    }

    if (state.items.length === 0) {
        listContainer.classList.add('hidden');
        emptyState.classList.remove('hidden');
    } else {
        listContainer.classList.remove('hidden');
        emptyState.classList.add('hidden');
    }
}

